import styled, { createGlobalStyle } from 'styled-components';
import theme from 'styled-theming';

const backgroundColorThead = theme('name', {
  light: 'rgba(242,242,242,255)',
  dark: 'rgba(70,70,70,255)',
});

const backgroundColorTh = theme('name', {
  light: 'rgb(242, 242, 242)',
  dark: '#FFFFFF17',
});

const pageBackground = theme('name', {
  light: 'rgb(242, 242, 242)',
  dark: '#1C1C1C',
});

const tableBorder = theme('name', {
  light: 'rgba(28, 28, 28, 0.14)',
  dark: '#504945',
});

const cardBorder = theme('name', {
  light: 'rgba(28, 28, 28, 0.12)',
  dark: 'rgba(255, 255, 255, 0.15)',
});

const filterActiveBackground = theme('name', {
  light: 'rgba(28, 28, 28, 0.72)',
  dark: 'rgba(255, 255, 255, 0.22)',
});

const filterPopupBackground = theme('name', {
  light: '#ffffff',
  dark: '#2b2b2b',
});

const filterPopupTextColor = theme('name', {
  light: '#1c1c1c',
  dark: '#ffffff',
});

const filterPopupBorderColor = theme('name', {
  light: 'rgba(28, 28, 28, 0.2)',
  dark: '#504945',
});

const filterIconColor = theme('name', {
  light: 'rgba(28, 28, 28, 0.72)',
  dark: 'rgba(255, 255, 255, 0.82)',
});

const filterIconHoverBackground = theme('name', {
  light: 'rgba(28, 28, 28, 0.1)',
  dark: 'rgba(255, 255, 255, 0.16)',
});

const ignoreButtonBorder = theme('name', {
  light: 'rgba(28, 28, 28, 0.32)',
  dark: 'rgba(255, 255, 255, 0.32)',
});

const ignoreButtonText = theme('name', {
  light: '#1c1c1c',
  dark: '#ffffff',
});

const ignoreButtonHoverBackground = theme('name', {
  light: 'rgba(28, 28, 28, 0.06)',
  dark: 'rgba(255, 255, 255, 0.1)',
});

const ignoredRowBackground = theme('name', {
  light: 'rgba(28, 28, 28, 0.04)',
  dark: 'rgba(255, 255, 255, 0.04)',
});

const ignoredRowTextColor = theme('name', {
  light: 'rgba(28, 28, 28, 0.45)',
  dark: 'rgba(255, 255, 255, 0.45)',
});

const profileTableHeadBackground = theme('name', {
  light: '#f2f2f2',
  dark: '#4a4a4a',
});

const profileTableHeadTextColor = theme('name', {
  light: '#1c1c1c',
  dark: '#ececec',
});

const profileTableEvenRowBackground = theme('name', {
  light: '#f2f2f2',
  dark: 'rgba(255, 255, 255, 0.06)',
});

const profileTableCellBorderColor = theme('name', {
  light: 'rgba(28, 28, 28, 0.14)',
  dark: 'rgba(255, 255, 255, 0.16)',
});

const profileTableCellTextColor = theme('name', {
  light: '#1c1c1c',
  dark: '#f3f3f3',
});

export const FlatDealsContainer = styled.div`
  /* Keep sticky headers and filters below modal backdrops without changing their local order. */
  isolation: isolate;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  .trading-balance {
    width: fit-content;
    margin-bottom: 16px;
    border: 1px solid ${cardBorder} !important;
  }

  .filter-divider {
    margin-left: 10px;
  }

  .daily-total {
    display: flex;
  }

  .total-trades-label {
    font-weight: 600;
    font-size: 15px;
    white-space: nowrap;
  }

  .daily-counts {
    display: flex;
  }

  .render-capacity {
    margin-left: 20px;
    display: flex;
    gap: 10px;
    align-items: center;
  }

  /* ── Filters — Card with labels above controls ── */
  .filters-card {
    background: ${(props) => props.theme.background.primary};
    border-radius: 4px;
    border: 1px solid ${cardBorder};
    box-shadow:
      rgba(0, 0, 0, 0.28) 0 1px 3px,
      rgba(0, 0, 0, 0.2) 0 0 1px;
    padding: 10px 15px;
    margin-bottom: 12px;
    overflow: visible;
    flex-shrink: 0;
  }

  .filters-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0;
    margin-bottom: 6px;
  }

  /* Left group — radio buttons + date pickers */
  .filters-date-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;

    /* Vertical stack of radio buttons */
    .radio-group {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }

  /* Vertical separator between the two groups */
  .filters-group-sep {
    width: 1px;
    height: 0;
    background: ${(props) => props.theme.border.medium};
    margin: 0 12px;
    flex-shrink: 0;
  }

  /* Right group — search, trade type, display unit */
  .filters-other-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 12px;
  }

  /* View toggle button group — positioned right before refresh, far right */
  .filters-view-toggle {
    display: flex;
    align-items: center;
    align-self: flex-end;
    margin-left: auto;
    margin-right: 12px;
    flex-shrink: 0;
  }

  /* Refresh button — at the far right of the filters row */
  .filters-refresh {
    align-self: flex-end;
    flex-shrink: 0;
  }

  .filter-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex-shrink: 0;
  }

  .filter-field-date {
    display: flex;
    flex-direction: column;
    gap: 4px;
    position: relative;
    z-index: 50;
  }

  .filter-label {
    font-size: 11px;
    font-weight: 600;
    color: ${(props) => props.theme.text.medium};
    white-space: nowrap;
  }

  .filter-search {
    width: 220px;
  }

  .filter-select {
    width: 130px;
  }

  .selected-filters-bar {
    display: flex;
    gap: 5px;
    margin-bottom: 10px;
    flex-wrap: wrap;
    flex-shrink: 0;

    .filter {
      display: flex;
      flex-wrap: wrap;
      width: auto;
      border: 1px dashed rgba(145, 158, 171, 0.16);
      padding: 8px;
      gap: 8px;
      border-radius: 8px;
      overflow: hidden;
      align-items: center;
    }

    .display-label {
      font-weight: 600;
      font-size: 13px;
    }

    .display-value {
      display: inline-flex;
      font-size: 12px;
      padding: 0 8px;
      border-radius: 8px;
      min-height: 24px;
      align-items: center;
      gap: 4px;
      line-height: 1;
      vertical-align: middle;
    }

    .display-value span {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      line-height: 1;
    }

    .badge-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 14px;
      height: 14px;
      min-width: 14px;
      padding: 0;
      margin-left: 4px;
      line-height: 1;
      vertical-align: middle;
    }

    .badge-button svg {
      width: 12px;
      height: 12px;
      display: block;

      path {
        fill: #fff;
      }
    }
  }

  /* ── Table wrapper (relative anchor for loader overlay) ── */
  .table-wrapper {
    flex: 1;
    min-height: 0;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  /* ── Table container (scrollable) ── */
  .table-container {
    border-radius: 5px 5px 0 0;
    flex: 1;
    min-height: 0;
    overflow: auto;
    scrollbar-width: auto;
    transition: opacity 0.15s ease;

    &.table-loading {
      opacity: 0.4;
      pointer-events: none;
    }

    /* WebKit — thicker, easier-to-grab scrollbar */
    &::-webkit-scrollbar {
      width: 14px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${(props) => props.theme.border.medium};
      border-radius: 5px;
      border: 2px solid transparent;
      background-clip: padding-box;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: ${(props) => props.theme.border.strong};
    }
  }

  .shell-table {
    width: max-content;
    min-width: 100%;
    table-layout: fixed;

    thead {
      position: sticky;
      top: 0;
      z-index: 8;
      background-color: ${backgroundColorThead};
    }

    thead th {
      padding: 6px 8px;
      background-color: ${backgroundColorTh};
      border: 1px solid ${tableBorder};
      font-weight: 700;
      white-space: nowrap;
      cursor: default;
      user-select: none;
      text-align: left;
      vertical-align: middle;
      position: relative;
      overflow: visible;

      &:nth-child(1) {
        width: 90px;
      }
      &:nth-child(2) {
        width: 120px;
      }
      &:nth-child(3) {
        width: 170px;
      }
      &:nth-child(4) {
        width: 160px;
      }
      &:nth-child(5) {
        width: 160px;
      }
      &:nth-child(6) {
        width: 110px;
      }
      &:nth-child(7) {
        width: 130px;
      }
      &:nth-child(8) {
        width: 160px;
      }
      &:nth-child(9) {
        width: 110px;
      }
      &:nth-child(10) {
        width: 100px;
      }
      &:nth-child(11) {
        width: 80px;
      }
    }

    tbody td {
      padding: 4px 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border: 1px solid ${tableBorder};
      height: 36px;
      vertical-align: middle;
    }

    .quantity {
      font-variant-numeric: tabular-nums;
    }

    /* Ignored deals — grayed out, no deal status */
    tbody tr.row-ignored td {
      background-color: ${ignoredRowBackground};
      color: ${ignoredRowTextColor};
    }
  }

  /* ── Sortable column header cursor ── */
  .th-sortable {
    cursor: pointer;
  }

  /* ── Column header filter wrapper (custom dropdown anchor) ── */
  .th-filter-wrapper {
    position: relative;
    flex-shrink: 0;
  }

  /* ── Sortable column headers ── */
  .th-cell {
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
    width: 100%;
  }

  .th-sort-trigger {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    user-select: none;
    flex: 1;
    min-width: 0;
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    color: inherit;
    text-align: left;

    .sort-icon {
      display: inline-flex;
      align-items: center;
      opacity: 0.45;
      flex-shrink: 0;
    }

    &:hover .sort-icon {
      opacity: 1;
    }
  }

  /* ── Column header filter button (Popover trigger) ── */
  .th-filter-btn {
    /* button reset */
    background: transparent;
    border: none;
    font: inherit;
    padding: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${filterIconColor};
    flex-shrink: 0;
    opacity: 0.9;
    margin-left: 4px;
    width: 18px;
    height: 18px;
    border-radius: 3px;

    /* stylelint-disable-next-line no-descending-specificity */
    svg {
      width: 12px;
      height: 12px;
      display: block;
    }

    &:hover {
      opacity: 1;
      background-color: ${filterIconHoverBackground};
    }

    &.active {
      opacity: 1;
      color: #fff;
      background-color: ${filterActiveBackground};
      border-radius: 3px;
      min-width: 18px;
      height: 18px;
      justify-content: center;
      margin-left: 4px;
      padding: 0;

      svg {
        width: 12px;
        height: 12px;
      }
    }
  }

  /* ── Ignore deal action (row action, not a link) ── */
  .ignore-deal-btn {
    align-self: flex-end;
    background: rgb(255, 198, 0);
    border: 1px solid rgb(255, 198, 0);
    border-radius: 4px;
    color: #202020;
    font: inherit;
    font-size: 13px;
    padding: 2px 10px;
    cursor: pointer;
    margin-top: 8px;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    &:hover:not(:disabled) {
      background-color: rgb(255, 198, 0);
      border-color: rgb(255, 198, 0);
    }
  }

  /* ── Profile data inspect icon (icon-only, no label) ── */
  .inspect-profile-btn {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${filterIconColor};

    &:hover {
      color: ${ignoreButtonText};
    }
  }

  /* ── Column filter custom dropdown panel ── */
  .col-filter-popup {
    position: absolute;
    top: calc(100% + 4px);
    left: 50%;
    transform: translateX(-50%);
    background: ${(props) => props.theme.background.primary};
    border: 1px solid ${(props) => props.theme.border.medium};
    border-radius: 4px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
    z-index: 100;
    min-width: 210px;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .col-filter-clear {
    align-self: flex-end;
    font-size: 11px;
    cursor: pointer;
    background: none;
    border: none;
    color: ${(props) => props.theme.text.link};
    padding: 0;

    &:hover {
      text-decoration: underline;
    }
  }

  /* ── Buy / Sell text ── */
  .buy-sell-text {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
  }

  /* ── Row count footer ── */
  .row-count {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    font-size: 12px;
    color: ${(props) => props.theme.text.medium};
    border-top: 1px solid ${tableBorder};
  }

  .row-count-loaded {
    margin-left: auto;
  }

  .row-count-total {
    font-weight: 600;
    color: ${(props) => props.theme.text.onSurface};
  }

  .row-count-sep {
    color: ${(props) => props.theme.text.medium};
  }

  /* ── Utility ── */
  .empty-cell {
    padding: 32px;
    text-align: center;
    font-size: 13px;
    color: ${(props) => props.theme.text.subtle};
  }

  .loading-more {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 20;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
  }

  .load-sentinel {
    height: 1px;
  }
`;

export const ColFilterGlobalStyle = createGlobalStyle`
  .import-message-tooltip {
    padding: 8px 10px;
    max-width: 320px;
    line-height: 1.35;
    white-space: normal;
    word-break: break-word;
  }

  .col-filter-popup-fixed {
    position: fixed;
    transform: translateX(-50%);
    background-color: ${filterPopupBackground};
    color: ${filterPopupTextColor};
    border: 1px solid ${filterPopupBorderColor};
    border-radius: 4px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
    opacity: 1;
    isolation: isolate;

    /* This body portal sits above the isolated page, but below modal backdrops. */
    z-index: 1;
    min-width: 210px;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .col-filter-popup-fixed-wide {
    min-width: 300px;
  }

  .col-filter-input-row-fixed {
    display: flex;
    align-items: center;
    gap: 8px;

    .shell-input-wrapper {
      flex: 1;
      min-width: 0;
    }
  }
`;

/* Profile Data table content rendered inside the shared System Admin Modal. */
export const ProfileModalGlobalStyle = createGlobalStyle`
  .deal-quantity-modal .shell-modal-container {
    margin: 24vh auto 0;
  }

  .deal-quantity-modal .shell-modal-container-content {
    max-height: 68vh;
    overflow: hidden;
  }

  .profile-modal-body {
    padding: 16px 0;
  }

  .deal-id {
    margin-bottom: 12px;
    font-size: 14px;
    color: ${profileTableCellTextColor};

    strong {
      font-weight: 700;
    }
  }

  .profile-modal-loading {
    display: flex;
    justify-content: center;
    padding: 24px 0;
  }

  .profile-modal-empty {
    text-align: center;
    padding: 20px;
    color: ${profileTableCellTextColor};
  }

  .profile-modal-table-scroll {
    overflow-y: auto;
    max-height: calc(68vh - 210px);
  }

  .profile-modal-table {
    width: 100%;

    thead {
      position: sticky;
      top: 0;
      z-index: 3;
      background: ${profileTableHeadBackground};
    }

    thead th {
      position: sticky;
      top: 0;
      z-index: 4;
      font-size: 12px;
      font-weight: 700;
      text-align: left;
      padding: 6px 10px;
      color: ${profileTableHeadTextColor};
      background: ${profileTableHeadBackground};
      border-bottom: 2px solid ${profileTableCellBorderColor};
    }

    tbody tr:nth-child(even) td {
      background: ${profileTableEvenRowBackground};
    }

    /* stylelint-disable-next-line no-descending-specificity */
    tbody td {
      font-size: 13px;
      padding: 6px 10px;
      color: ${profileTableCellTextColor};
      border-bottom: 1px solid ${profileTableCellBorderColor};
    }
  }
`;
